export default __webpack_public_path__ + "static/media/v1-sa.5c230daf.png";